import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {CalculateType, DefaultDropdown, defaultTax, defaultValue, defaultVat, DropdownDatas, hundredPercent} from '../../datas';
import { isEmpty, isNumber } from 'lodash';

@Component({
  selector: 'app-calculate-box',
  templateUrl: './calculate-box.component.html',
  styleUrls: ['./calculate-box.component.scss']
})
export class CalculateBoxComponent implements OnInit {

  total: string;
  beforeVat: string;
  calVat: string;
  totalWithVat: string;
  calTax: string;
  totalWithTax: string;
  compareNumber: string;

  form: FormGroup;
  dropdownItems = DropdownDatas;
  selectedItem = DefaultDropdown;
  calType = CalculateType;

  @Output() finishedCalChange = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
    this.total = defaultValue;
    this.form = new FormGroup({
      tax: new FormControl(defaultTax, []),
      vat: new FormControl(defaultVat, [])
    });
  }

  onNumberChange(): void {

  }

  onDdlItemClick(value): void {
    this.selectedItem = value;
  }

  getRawNumberValue(input) {
    let val = input;
    if (!isNumber(input) && !isEmpty(input)) {
      input = parseFloat(input.replace(/(,)/g, ''));
      if (isNaN(input)) {
        val = val.toString();
      } else {
        val = input;
      }
    }
    return val;
  }

  calculateTax(): void {
    const rawVat = this.getRawNumberValue(this.form.value.vat);
    const rawTax = this.getRawNumberValue(this.form.value.tax);
  	const vatValue = isNaN(rawVat) || !rawVat? defaultValue : rawVat;
    const taxValue = isNaN(rawTax) || !rawTax ? defaultValue : rawTax;
    const percentVat = parseFloat(vatValue) / hundredPercent;
    const percentTax = parseFloat(taxValue) / hundredPercent;
    const inputNumber = parseFloat(this.total).toFixed(2);

    if (this.selectedItem.id === this.calType.beforeVat) {
      this.beforeVat = inputNumber;
    } else if (this.selectedItem.id === this.calType.withVat) {
      this.beforeVat = (parseFloat(inputNumber) - parseFloat(
        (parseFloat(
          (parseFloat(inputNumber) * parseFloat(vatValue)).toFixed(2)
        ) / (100 + parseFloat(vatValue))).toFixed(2))).toFixed(2);
    } else {
      this.beforeVat = ((parseFloat(inputNumber) * 100) /
        (100 + (parseFloat(vatValue) - parseFloat(taxValue)))).toFixed(2);
      this.calVat = (parseFloat(this.beforeVat) * percentVat).toFixed(2);
    }

    this.calVat = (parseFloat(this.beforeVat) * percentVat).toFixed(2);
    this.totalWithVat = (parseFloat(this.beforeVat) + parseFloat(this.calVat)).toFixed(2);
    this.calTax = (parseFloat(this.beforeVat) * percentTax).toFixed(2);
    this.totalWithTax = (parseFloat(this.beforeVat) + parseFloat(this.calVat) - parseFloat(this.calTax)).toFixed(2);

    if (this.selectedItem.id === this.calType.beforeVat) {
      this.compareNumber = this.beforeVat;
    } else if (this.selectedItem.id === this.calType.withVat) {
      this.compareNumber = this.totalWithVat;
    } else {
      this.compareNumber = this.totalWithTax;
    }

    this.finishedCalChange.emit({
      inputNumber: this.fixNumber(inputNumber),
      compareNumber: this.fixNumber(this.compareNumber),
      vat: vatValue,
      tax: taxValue,
      beforeVat: isNaN(Number(this.beforeVat)) ? defaultValue : this.fixNumber(this.beforeVat),
      calVat: isNaN(Number(this.calVat)) ? defaultValue : this.fixNumber(this.calVat),
      totalWithVat: isNaN(Number(this.totalWithVat)) ? defaultValue : this.fixNumber(this.totalWithVat),
      calTax: isNaN(Number(this.calTax)) ? defaultValue : this.fixNumber(this.calTax),
      totalWithTax: isNaN(Number(this.totalWithTax)) ? defaultValue : this.fixNumber(this.totalWithTax)
    });
    document.documentElement.scrollTop = 0;
  }

  fixNumber(input: string): string {
    return input.includes('.00') ? Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number(input)) : Intl.NumberFormat('th-TH', {
      style: 'currency',
      currency: 'THB'
    }).format(Number(input));
  }
}
